import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47fb6ec5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row main-container" }
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 filter-pane ml-1" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-12" }
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Date", -1))
const _hoisted_9 = { class: "col-sm-9" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-3 col-form-label",
  for: "fromdate"
}, "From", -1))
const _hoisted_14 = { class: "col-sm-9" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "fas fa-2x fa-check-circle text-success ml-auto float-right"
}
const _hoisted_23 = { class: "col-sm-12" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  class: "col-sm-12 mb-3",
  style: {"display":"flex","flex-direction":"column","justify-content":"center"}
}
const _hoisted_26 = {
  key: 0,
  class: "fas fa-2x fa-check-circle text-success ml-auto float-right"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-sm-12" }
const _hoisted_29 = { class: "form-group row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Search text", -1))
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-sm-12" }
const _hoisted_34 = { class: "form-group row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Job type", -1))
const _hoisted_36 = { class: "col-sm-6" }
const _hoisted_37 = {
  key: 1,
  class: "row"
}
const _hoisted_38 = { class: "col-sm-12" }
const _hoisted_39 = { class: "form-group row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Internal job type", -1))
const _hoisted_41 = { class: "col-sm-6" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-sm-12" }
const _hoisted_44 = { class: "form-group row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Client", -1))
const _hoisted_46 = { class: "col-sm-6" }
const _hoisted_47 = {
  key: 2,
  class: "row"
}
const _hoisted_48 = { class: "col-sm-12" }
const _hoisted_49 = { class: "form-group row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Branch", -1))
const _hoisted_51 = { class: "col-sm-6" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-sm-12" }
const _hoisted_54 = { class: "form-group row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Who", -1))
const _hoisted_56 = { class: "col-sm-6" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-sm-12" }
const _hoisted_59 = { class: "form-group row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Access", -1))
const _hoisted_61 = { class: "col-sm-6" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-sm-12" }
const _hoisted_64 = { class: "form-group row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Access confrimed", -1))
const _hoisted_66 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-sm-12" }
const _hoisted_69 = { class: "form-group row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Flexi Appointments", -1))
const _hoisted_71 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-sm-12" }
const _hoisted_74 = { class: "form-group row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Predicted travel time exceeds/falls short of scheduled allowance", -1))
const _hoisted_76 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-sm-12" }
const _hoisted_79 = { class: "form-group row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Tenant attending", -1))
const _hoisted_81 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-sm-12" }
const _hoisted_84 = { class: "form-group row" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing tenant name", -1))
const _hoisted_86 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-sm-12" }
const _hoisted_89 = { class: "form-group row" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing tenant mobile", -1))
const _hoisted_91 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-sm-12" }
const _hoisted_94 = { class: "form-group row" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing tenant email", -1))
const _hoisted_96 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "col-sm-12" }
const _hoisted_99 = { class: "form-group row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing landlord mobile", -1))
const _hoisted_101 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_102 = {
  key: 3,
  class: "row"
}
const _hoisted_103 = { class: "col-sm-12" }
const _hoisted_104 = { class: "form-group row" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing Uploads or linked report reference", -1))
const _hoisted_106 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col-sm-12" }
const _hoisted_109 = { class: "form-group row" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Check-In/Check-Out time conflicting with schedule", -1))
const _hoisted_111 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_112 = { class: "row" }
const _hoisted_113 = { class: "col-sm-12" }
const _hoisted_114 = { class: "form-group row" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Provisional", -1))
const _hoisted_116 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_117 = { class: "row" }
const _hoisted_118 = { class: "col-sm-12" }
const _hoisted_119 = { class: "form-group row" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "In absence", -1))
const _hoisted_121 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_122 = { class: "row" }
const _hoisted_123 = { class: "col-sm-12" }
const _hoisted_124 = { class: "form-group row" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Deleted", -1))
const _hoisted_126 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_127 = { class: "row" }
const _hoisted_128 = { class: "col-sm-12" }
const _hoisted_129 = { class: "form-group row" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing landlord name", -1))
const _hoisted_131 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_132 = { class: "row" }
const _hoisted_133 = { class: "col-sm-12" }
const _hoisted_134 = { class: "form-group row" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing landlord email", -1))
const _hoisted_136 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_137 = { class: "row" }
const _hoisted_138 = { class: "col-sm-12" }
const _hoisted_139 = { class: "form-group row" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Missing works/purchase order number", -1))
const _hoisted_141 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_142 = { class: "row" }
const _hoisted_143 = { class: "col-sm-12" }
const _hoisted_144 = { class: "form-group row" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Not paid", -1))
const _hoisted_146 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_147 = { class: "row" }
const _hoisted_148 = { class: "col-sm-12" }
const _hoisted_149 = { class: "form-group row" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Key release unconfirmed", -1))
const _hoisted_151 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_152 = { class: "row" }
const _hoisted_153 = { class: "col-sm-12" }
const _hoisted_154 = { class: "form-group row" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Smoke and CO alarm form at Inv/CI", -1))
const _hoisted_156 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_157 = { class: "row" }
const _hoisted_158 = { class: "col-sm-12" }
const _hoisted_159 = { class: "form-group row" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Summary email following CO", -1))
const _hoisted_161 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_162 = { class: "row" }
const _hoisted_163 = { class: "col-sm-12" }
const _hoisted_164 = { class: "form-group row" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Not issued", -1))
const _hoisted_166 = { class: "col-sm-6 mt-2 mb-2" }
const _hoisted_167 = { class: "col-md-4" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "SMS/Email responses", -1))
const _hoisted_169 = { key: 0 }
const _hoisted_170 = {
  key: 0,
  class: "row"
}
const _hoisted_171 = { class: "col-sm-12" }
const _hoisted_172 = { class: "form-group row" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-7" }, null, -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Sort")
], -1))
const _hoisted_175 = { class: "col-sm-4" }
const _hoisted_176 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_177 = { class: "container-fluid" }
const _hoisted_178 = { class: "col-md-2 pl-0 pr-0" }
const _hoisted_179 = { class: "row" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 pl-0 pr-0" }, null, -1))
const _hoisted_181 = { class: "col-md-6 pl-0 pr-0" }
const _hoisted_182 = ["disabled"]
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))

import {
  ref,
  computed,
  onMounted,
  watch,
  inject,
  nextTick,
  onBeforeUnmount, 
  onUnmounted
} from "vue";
import { useStore } from "vuex";
import Ably from "ably";
import { ModalsContainer, useVfm } from "vue-final-modal";
import moment from "moment-timezone";
import { checkBooking } from "@/bookingfilterpresets";

import { DxDateBox } from "devextreme-vue/date-box";
import DraggableModal from "@/components/modals/DraggableModal.vue";
import TriStateToggle from "@/components/TriStateToggle.vue";
import ManagementResults from "./ManagementResults.vue";
import UnreadSmsEmailLogs from "./managementfilters/UnreadSmsEmailLogs.vue";
import GoogleEventModal from "@/components/modals/GoogleEventModal.vue";
import AuditlogsModal from "@/components/modals/AuditlogsModal.vue";
import BookingCancelModal from "@/components/modals/BookingCancelModal.vue";
import { DxSwitch } from "devextreme-vue/switch";
import { useToast } from "vue-toastification";
import UndoSaveToaster from "@/components/modals/UndoSaveToaster.vue";
import {
  Inspector,
  PropertySpec,
  Booking,
  DictionaryReportType,
  SelectOption,
  Document,
  Customer,
  PresetError,
  User,
} from "@/models";

export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementFilters',
  emits: [
  "showpricelistdocument",
  "showworksorderdocument",
  "showpricelistdocument",
],
  setup(__props, { emit: __emit }) {

const realtime: Ably.Realtime = inject("realtime");
const actProperty: any = inject("actProperty");
const channel = realtime.channels.get("diary");
const deviceid = actProperty.getDeviceId();
const toasted = useToast();
const store = useStore();
const emit = __emit;

const auditLogsModal = ref(null);
const googleeventmodal = ref(null);
const bookingCancelModal = ref(null);
const sortedunreadsmslogsresults = ref<Booking[]>([]);
const todaysunreadsmslogsresults = ref<Booking[]>([]);
const daterangeunreadsmslogsresults = ref<Booking[]>([]);
const futureunreadsmslogsresults = ref<Booking[]>([]);
const managementResults = ref(null);
// Filters
const datefiltertype = ref("");
const datefiltertypeoptions = ref([
  "Today",
  "Tomorrow",
  "Day after tomorrow",
  "Next 2 days",
  "Next 3 days",
  "Next 7 days",
  "Date range",
]);
const filterbookingtypeoptions = ref([
  "Client",
  "Time & Date",
  "Job type",
  "PI",
]);
const filterbookingtype = ref("Client");
const predictedtraveltime = ref("");
const predictedtraveltimeoptions = ref([
  "-40",
  "-30",
  "-20",
  "-10",
  "10",
  "20",
  "30",
  "40+",
]);
const flexiappoitment = ref("");
const flexiappoitmentslist = ref([
  "Flexi all day",
  "Flexi AM",
  "Flexi PM",
  "All",
]);
const paramsset = ref();
const fromdate = ref(new Date());
const todate = ref(new Date());
const anytext = ref("");
const jobtype = ref<DictionaryReportType>(new DictionaryReportType());
const internaljobtype = ref("");
const reorderedinternaljobtypelist = ref([]);
const companyname = ref("");
const branchname = ref("");
const companyNameOptions = ref([]);
const branchNameOptions = ref([]);
const presentErrors = ref([]);
const inspector = ref<SelectOption>(new SelectOption());
const access = ref("");
const accessOptions = ref([
  "From Agency",
  "Meet Tenant",
  "Via Concierge",
  "Via Landlord",
  "TBC",
  "Misc",
]);
const accessconfirmed = ref("");
const accessconfirmedOptions = ref(["Confirmed", "Not confirmed"]);
const tenantattending = ref("");
const missingtenantname = ref(false);
const missingtenantmobile = ref(false);
const missingtenantemail = ref(false);
const missinguploadorreportref = ref(false);
const uploadorlinkjobtypelist = ref([
  "Inv CI - off upload",
  "Inv CI - old report on file, charge CI rate",
  "Check-Out - off ACT report",
  "Check-Out - off upload",
  "Check-In - off ACT report",
  "Check-In - off upload",
]);
const cicotimeconflict = ref(false);
const inabsence = ref(false);
const provisional = ref(false);
const safetycleats = ref(false);
const summaryemailafterco = ref(false);
const tbc = ref(false);
const cancelled = ref(false);
const missingllname = ref(false);
const missingllmobile = ref(false);
const missingllemail = ref(false);
const missingworksorder = ref(false);
const notpaid = ref(false);
const keyreleaseunconfirmed = ref(false);
const keyreturntbc = ref(false);
const smokecoalarmrequired = ref(false);
const notissued = ref(false);
const originalbooking = ref();

const results = ref<Booking[]>([]);
const showresultlist = ref(false);
const futureBookingId = ref("");
const googlebooking = ref<Booking>(new Booking());

const selectedbooking = computed(
  () => store.getters["diary/booking"] as Booking
);
const propertyspec = computed(
  () => store.getters["diary/propertyspec"] as PropertySpec
);
const customer = computed(() => store.getters["diary/customer"] as Customer);
const reportTypes = computed(
  () =>
    store.getters["dictionary/reportTypes"] as
      | DictionaryReportType[]
      | undefined
);
const jobtypelist = computed(() => store.getters["diary/jobtypelist"]);
const jobtypemap = computed(() => store.getters["diary/jobtypemap"]);
const inspectors = computed(
  (): Inspector[] => store.getters["diary/inspectorlist"]
);
const internaljobtypedisplayname = computed(
  (): Map<string, string> => store.getters["diary/internaljobtypedisplayname"]
);
const customers = computed(() => store.getters["diary/customerlist"]);
const setBookingDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch("diary/setBookingDeep", payload);
};

const users = computed((): User[] => store.getters['usermanagement/users']);

const getCompanyNameOptions = async (managedtype?: string): Promise<any> => {
  return await store.dispatch("diary/getCompanyNameOptions", managedtype);
};
const setBooking = (booking: any) => {
  store.commit("diary/setBooking", booking);
};

const markSMSEmailAsRead = async (booking: Booking) => {
  return await store.dispatch("diary/markSMSEmailAsRead", booking);
};

const getBranchNameOptionsWithManagedtype = async (payload?: {
  company_name?: string;
  managedtype?: string;
}): Promise<any> => {
  return await store.dispatch(
    "diary/getBranchNameOptionsWithManagedtype",
    payload
  );
};

const managementBookingSearch = async (params: any): Promise<Booking[]> => {
  return await store.dispatch("diary/managementBookingSearch", params);
};
// Methods
const getUnreadSmsLogs = (params: any): Promise<Booking[]> => {
  return store.dispatch("diary/getUnreadSMSLogs", params);
};
const getUnreadEmailLogs = (params: any): Promise<Booking[]> => {
  return store.dispatch("diary/getUnreadEmailLogs", params);
};
const getBookingWithoutStoringInState = (payload: {
  id: string;
  cancelled: string;
}) => {
  return store.dispatch("diary/getBookingWithoutStoringInState", payload);
};
const floorplan = computed(() => propertyspec.value.floorplan);
const dataentrydocuments = computed(
  () => selectedbooking.value.dataentrydocuments
);
const ratedocument = computed(() => {
  if (
    customer.value &&
    customer.value.pricelist &&
    customer.value.pricelist.length
  )
    return customer.value.pricelist[0];
  else return new Document();
});
const ensureFromDateIsAfterToDate = () => {
  if (todate.value) {
    if (
      fromdate.value &&
      moment(fromdate.value).utc().isAfter(moment(todate.value).utc())
    ) {
      fromdate.value = todate.value;
    }
  }
};

const ensureToDateIsBeforeFromDate = () => {
  if (fromdate.value) {
    if (
      todate.value &&
      moment(todate.value).utc().isBefore(moment(fromdate.value).utc())
    ) {
      todate.value = fromdate.value;
    }
  }
};

const jobtypeoptions = computed(() => {
  return reportTypes.value.filter(
    (t: DictionaryReportType) => jobtypelist.value.indexOf(t.slug) >= 0
  );
});
const customLabelForReportType = (type: DictionaryReportType) => {
  return type == null ? DictionaryReportType : type.displayname;
};

watch(
  () => jobtype.value,
  (newValue: any, oldValue: any) => {
    if (
      !oldValue ||
      (newValue != null && newValue && newValue.slug != oldValue.slug)
    ) {
      if (jobtype.value && jobtype.value.slug) {
        let templist = jobtypemap.value.get(jobtype.value?.slug);
        if (templist) reorderedinternaljobtypelist.value = templist;
        if (
          reorderedinternaljobtypelist.value &&
          reorderedinternaljobtypelist.value.length == 1
        ) {
          internaljobtype.value = reorderedinternaljobtypelist.value[0];
        }
        let index = reorderedinternaljobtypelist.value.indexOf(
          internaljobtype.value
        );
        if (index < 0) internaljobtype.value = "";
      }
    }
  }
);
const companyNameList = async () => {
  await getCompanyNameOptions().then((options: any) => {
    companyNameOptions.value = options;
  })
  .then(() => { companyNameOptions.value = companyNameOptions.value.filter((o: string) => o.trim().length)})
  .then(() => {
    // Add profiles on the top
    if(users.value?.length) {
      const portfoliooptions = users.value.filter((u: User) => u.customers?.length)
        .map((u: User) => `CRM Portfolio ${u.name}`).sort();
        companyNameOptions.value = [...portfoliooptions, ...companyNameOptions.value]
    }
  });
};

const setBranchnameOptions = (val: string) => {
  getBranchNameOptionsWithManagedtype({
    company_name: companyname.value,
  }).then((options: any) => (branchNameOptions.value = options));
};

const inspectorlist = computed((): SelectOption[] => {
  return inspectors.value.map(
    (i) => new SelectOption({ name: i.name, slug: i.id })
  );
});
const getAllCustomers = (): Promise<any> => {
  return store.dispatch("diary/getAllCustomers");
};

const logsReletedFunctions = async (params: any) => {
  sortedunreadsmslogsresults.value = [];
  await getUnreadSmsLogs({}).then((bookings: Booking[]) => {
    const smsBookingArray: Booking[] = bookings;
    // bookings.forEach((f: Booking) => {
    //   const smsfilterLogs = f.smslogs.logs.filter((sms: SMSLog) => sms.unread === true);
    //   smsfilterLogs.forEach((sms: SMSLog) => {
    //     const b: Booking = new Booking(f);
    //     b.smslogs.logs = [sms];
    //     smsBookingArray.push(b);
    //   });
    // });
    smsBookingArray.sort((a, b) => {
      const dateA: Date = new Date(a.smslogs.logs[0]?.logdate);
      const dateB: Date = new Date(b.smslogs.logs[0]?.logdate);
      return dateA.getTime() - dateB.getTime();
    });
    sortedunreadsmslogsresults.value = smsBookingArray;
  });
  await getUnreadEmailLogs({}).then((bookings: Booking[]) => {
    const emailBookingArray: Booking[] = bookings;
    // bookings.forEach((f: Booking) => {
    //   const emailfilterLogs = f.emaillogs.tenantemaillogs.filter((email: EmailLog) => email.unread === true && email.tenantresponse === 'callback');
    //   emailfilterLogs.forEach((email: EmailLog) => {
    //     const b: Booking = new Booking(f);
    //     b.emaillogs.tenantemaillogs = [email];
    //     emailBookingArray.push(b);
    //   });
    // });
    emailBookingArray.sort((a, b) => {
      const dateA: Date = new Date(a.emaillogs.tenantemaillogs[0]?.logdate);
      const dateB: Date = new Date(b.emaillogs.tenantemaillogs[0]?.logdate);
      return dateA.getTime() - dateB.getTime();
    });
    sortedunreadsmslogsresults.value = [
      ...sortedunreadsmslogsresults.value,
      ...emailBookingArray,
    ];
  });
  commanFunction();
};

const allPresets = async () => {
  const errors = [
    {
      message: "Upload missing",
      presetnumber: 1,
      flag: false,
    },
    {
      message: "Upload not typed up",
      presetnumber: 2,
      flag: false,
    },
    {
      message: "Check-In time outside of booking slot",
      presetnumber: 3,
      flag: false,
    },
    {
      message: "Time conflict when access via Tenant",
      presetnumber: 4,
      flag: false,
    },
    {
      message: "Access via agency but agency is shut",
      presetnumber: 7,
      flag: false,
    },
    {
      message: "Tenant access for Check-Out unconfirmed",
      presetnumber: 5,
      flag: false,
    },
    {
      message: "Key access unconfirmed (excluding via TT for Check-Out)",
      presetnumber: 6,
      flag: false,
    },
    {
      message: "Provisional booking",
      presetnumber: 8,
      flag: false,
    },
    {
      message: "Access via concierge and no email attached",
      presetnumber: 9,
      flag: false,
    },
  ];

  presentErrors.value = errors;
};

const updateManageFilter = async (selectbooking: Booking, fromflag: string) => {
  // let index = results.value.findIndex(
  //   (f: Booking) => f.id === selectbooking.id
  // );
  // if (index === -1) {
  //   channel.publish("appointmentSelected", {
  //     deviceid: deviceid,
  //     bookingid: selectbooking.id,
  //     inspectorid: selectbooking.inspector?.id,
  //     googleid: selectbooking.googleid,
  //     subtype: selectbooking.subtype,
  //     jobtype: selectbooking.jobtype,
  //     bookingdate: selectbooking.bookingdate,
  //   });
  //   if (fromflag === "fromunreadmessages") results.value = [];
  //   results.value.unshift(selectbooking);
  // }
};

onMounted(async () => {
  channel.subscribe("appointmentChanged", async (message: any) => {
    if (message?.data && message?.data.bookingid) {
      if (
        message.data.source === "DiaryForm" ||
        message.data.source === "Scheduler"
      ) {
        const index = results.value.findIndex(
          (b: Booking) => b.id === message.data.bookingid
        );
        if (index >= 0) {
          getBookingWithoutStoringInState({
            id: message.data.bookingid,
            cancelled: "false",
          }).then(async (b: Booking) => {
            if (b.preseterrors.length == 0) {
              results.value = results.value.filter(
                (f: Booking) => f.id != message?.data.bookingid
              );
            } else {
              results.value[index] = b;
            }
          });
        }
      } else if (
        message.data.source === "smslambda" ||
        message.data.source === "emaillambda"
      ) {
        getBookingWithoutStoringInState({
          id: message.data.bookingid,
          cancelled: "false",
        }).then(async (b: Booking) => {
          if (message.data.source === "smslambda") {
            const index = sortedunreadsmslogsresults.value.findIndex(
              (f: Booking) => f.id === b.id && f.smslogs.logs.length > 0
            );
            if (index >= 0) {
              sortedunreadsmslogsresults.value.splice(index, 1);
              commanFunction();
            }
          } else if (message.data.source === "emaillambda") {
            const index = sortedunreadsmslogsresults.value.findIndex(
              (f: Booking) =>
                f.id === b.id && f.emaillogs.tenantemaillogs.length > 0
            );
            if (index >= 0) {
              sortedunreadsmslogsresults.value.splice(index, 1);
              commanFunction();
            }
          }
        });
      }
    }
  });

  channel.subscribe("bookingConfirmResponse", async (message: any) => {
    if (message?.data && message?.data.bookingid && message?.data.unread) {
      const index = sortedunreadsmslogsresults.value.findIndex(
        (b: Booking) => b.id === message.data.bookingid
      );
      getBookingWithoutStoringInState({
        id: message.data.bookingid,
        cancelled: "false",
      }).then(async (b: Booking) => {
        if (index >= 0) {
          sortedunreadsmslogsresults.value[index] = b;
        } else {
          sortedunreadsmslogsresults.value.push(b);
        }
        sortedunreadsmslogsresults.value.sort((a, b) => {
          const dateA: Date = new Date(a.smslogs.logs[0]?.logdate);
          const dateB: Date = new Date(b.smslogs.logs[0]?.logdate);
          return dateA.getTime() - dateB.getTime();
        });
        sortedunreadsmslogsresults.value.sort((a, b) => {
          const dateA: Date = new Date(a.emaillogs.tenantemaillogs[0]?.logdate);
          const dateB: Date = new Date(b.emaillogs.tenantemaillogs[0]?.logdate);
          return dateA.getTime() - dateB.getTime();
        });
        commanFunction();
      });
    }
  });

  channel.subscribe("bookinglocked", (message: any) => {
    if (message?.data?.bookingid) {
      results.value.forEach((b: Booking, i: number) => {
        if (b.id === message.data.bookingid) {
          results.value[i].locked = true;
          results.value[i].lockedby = message.data.lockedby;
        } else if (b.lockedby === message.data.lockedby) {
          results.value[i].locked = false;
          results.value[i].lockedby = "";
        }
      });
    }
  });
  channel.subscribe("bookingunlocked", (message: any) => {
    if (message?.data?.bookingid) {
      results.value.forEach((b: Booking, i: number) => {
        if (b.id === message.data.bookingid) {
          results.value[i].locked = false;
          results.value[i].lockedby = "";
        } else if (b.lockedby === message.data.lockedby) {
          results.value[i].locked = false;
          results.value[i].lockedby = "";
        }
      });
    }
  });
  channel.subscribe("bookinginprogress", (message: any) => {
    if (message?.data?.bookingid) {
      results.value.forEach((b: Booking, i: number) => {
        if (b.id === message.data.bookingid) {
          results.value[i].inprogress = true;
        }
      });
    }
  });
  channel.subscribe("bookingnotinprogress", (message: any) => {
    if (message?.data?.bookingid) {
      results.value.forEach((b: Booking, i: number) => {
        if (b.id === message.data.bookingid) {
          results.value[i].inprogress = false;
        }
      });
    }
  });
  allPresets();
  await getAllCustomers();
  await logsReletedFunctions({});
  await companyNameList();
  channel.subscribe("appointmentCancelled", (message: any) => {
    if (message?.data) {
      setBookingDeep({ path: "cancelled", data: true });
      results.value
        .filter((b: Booking) => b.id === message.data)
        .forEach((b: Booking) => (b.cancelled = true));
    }
  });
});

onBeforeUnmount(() => {
  channel.unsubscribe("appointmentChanged");
  channel.unsubscribe("bookingConfirmResponse");
  channel.unsubscribe("bookinglocked");
  channel.unsubscribe("bookingunlocked");
  channel.unsubscribe("bookinginprogress");
  channel.unsubscribe("bookingnotinprogress");
  channel.unsubscribe("appointmentCancelled");
});

const tenantAttendingSelect = (val: string) => {
  if (val === "neutral") val = "unsure";
  if (tenantattending.value != val) {
    tenantattending.value = val;
  } else {
    tenantattending.value = "";
  }
};

const isuploadorlinktypejob = computed(() => {
  let result = -1;
  if (internaljobtype.value)
    result = uploadorlinkjobtypelist.value.findIndex(
      (t: string) => internaljobtype.value === t
    );
  return result >= 0;
});

const dateRangeFn = () => {
  let params: any = {};
  if (datefiltertype.value) {
    let todaymoment = moment(new Date()).utc();
    switch (datefiltertype.value) {
      case "Today":
        let today: string = todaymoment.format("DD-MM-YYYY");
        params.fromdate = today;
        params.todate = today;
        break;
      case "Tomorrow":
        let tomorrowmoment = todaymoment.add(1, "days");
        params.fromdate = tomorrowmoment.format("DD-MM-YYYY");
        params.todate = tomorrowmoment.format("DD-MM-YYYY");
        break;
      case "Day after tomorrow":
        let datmoment = todaymoment.add(2, "days");
        params.fromdate = datmoment.format("DD-MM-YYYY");
        params.todate = datmoment.format("DD-MM-YYYY");
        break;
      case "Next 2 days":
        params.fromdate = todaymoment.format("DD-MM-YYYY");
        params.todate = todaymoment.add(2, "days").format("DD-MM-YYYY");
        break;
      case "Next 3 days":
        params.fromdate = todaymoment.format("DD-MM-YYYY");
        params.todate = todaymoment.add(3, "days").format("DD-MM-YYYY");
        break;
      case "Next 7 days":
        params.fromdate = todaymoment.format("DD-MM-YYYY");
        params.todate = todaymoment.add(7, "days").format("DD-MM-YYYY");
        break;
      case "Date range":
        if (fromdate.value && todate.value) {
          params.fromdate = moment(fromdate.value).utc().format("DD-MM-YYYY");
          params.todate = moment(todate.value).utc().format("DD-MM-YYYY");
        } else {
          actProperty.displayError("From/to date cannot be empty");
        }
        break;
      case "All dates":
        params.fromdate = "";
        params.todate = "";
        break;
    }
  }
  return params;
};

const search = async () => {
  let params: any = {};
  results.value = [];
  let dateRange = await dateRangeFn();
  params.fromdate = dateRange.fromdate;
  params.todate = dateRange.todate;
  if (anytext.value) params.anytext = anytext.value;
  if (jobtype.value && jobtype.value.name) params.jobtype = jobtype.value.slug;
  if (internaljobtype.value) params.internaljobtype = internaljobtype.value;
  if (companyname.value) params.companyname = companyname.value;
  if (branchname.value) params.branchname = branchname.value;
  if (companyname.value && branchname.value) {
    const selectedcustomer = customers.value.find(
      (c: Customer) =>
        c.companyName === companyname.value && c.branchName === branchname.value
    );
    if (selectedcustomer?.id) {
      params.customerid = selectedcustomer.id;
    }
  }
  else if(companyname.value && !branchname.value) {
    if(companyname.value?.startsWith('CRM Portfolio')) {
      params.companyname = '';
      params.branchname = '';
      const index = users.value.findIndex((u: User) => u.name.startsWith(companyname.value.replace('CRM Portfolio ','')));
      if(index >= 0 && users.value[index].customers?.length) {
        params.customerids = users.value[index].customers.map((c: Customer) => c.id).join(',');
      }
    }
    else {
      const selectedcustomers = customers.value.filter(
        (c: Customer) =>
          c.companyName === companyname.value
      );
      if (selectedcustomers?.length) {
        params.customerids = selectedcustomers.map((c: Customer) => c.id).join(',');
      }
    }
  }
  if (inspector.value && inspector.value.slug)
    params.inspectorid = inspector.value.slug;
  if (access.value) params.access = access.value;
  if (accessconfirmed.value === "Confirmed") params.accessconfirmed = "true";
  else if (accessconfirmed.value === "Not confirmed")
    params.accessconfirmed = "false";
  if (tenantattending.value) params.tenantattending = tenantattending.value;
  if (missingtenantname.value)
    params.missingtenantname = missingtenantname.value;
  if (missingtenantmobile.value)
    params.missingtenantmobile = missingtenantmobile.value;
  if (missingtenantemail.value)
    params.missingtenantemail = missingtenantemail.value;
  if (missinguploadorreportref.value)
    params.missinguploadorreportref = missinguploadorreportref.value;
  if (cicotimeconflict.value) params.cicotimeconflict = cicotimeconflict.value;
  if (inabsence.value) params.inabsence = inabsence.value;
  if (provisional.value) params.provisional = provisional.value;
  if (smokecoalarmrequired.value)
    params.smokecoalarmrequired = smokecoalarmrequired.value;
  if (notissued.value) params.notissued = notissued.value;
  if (safetycleats.value) params.safetycleats = safetycleats.value;
  if (summaryemailafterco.value)
    params.summaryemailafterco = summaryemailafterco.value;
  if (tbc.value) params.tbc = tbc.value;
  if (cancelled.value) params.cancelled = cancelled.value;
  if (missingllname.value) params.missingllname = missingllname.value;
  if (missingllmobile.value) params.missingllmobile = missingllmobile.value;
  if (missingllemail.value) params.missingllemail = missingllemail.value;
  if (missingworksorder.value)
    params.missingworksorder = missingworksorder.value;
  if (notpaid.value) params.notpaid = notpaid.value;
  if (keyreleaseunconfirmed.value)
    params.keyreleaseunconfirmed = keyreleaseunconfirmed.value;
  if (keyreturntbc.value) params.keyreturntbc = keyreturntbc.value;
  if (flexiappoitment.value) params.flexiappoitment = flexiappoitment.value;
  if (predictedtraveltime.value)
    params.predictedtraveltime = predictedtraveltime.value;
  let presentErrorArray = presentErrors.value
    .filter((f) => f.flag)
    .map((m) => m.presetnumber);
  if (presentErrorArray.length) {
    params.presetnumbers = presentErrorArray.join(",");
  }

  const queryparams = Object.keys(params).filter(
    (p) => p != "fromdate" && p != "todate"
  );
  if (queryparams.length) {
    paramsset.value = params;
    managementBookingSearch(params).then((bookings: Booking[]) => {
      if (keyreturntbc.value || presentErrorArray.length) {
        let noPersonalBookings = bookings.filter(
          (f: Booking) =>
            f.jobtype != Booking.PERSONAL && f.subtype != Booking.PERSONAL
        );
        let onlyPrepAndKeyBookings = noPersonalBookings.filter(
          (f: any) => f.subtype !== Booking.PREP && f.subtype !== Booking.KEY
        );
        let onlyMasterIdsList = onlyPrepAndKeyBookings.map(
          (f: Booking) => f.id
        );
        let masterbookingidlistunderprepandkey = noPersonalBookings
          .filter(
            (f: any) =>
              (f.subtype === Booking.PREP || f.subtype === Booking.KEY) &&
              !onlyMasterIdsList.includes(f.leadbooking.id)
          )
          .map((f: Booking) => f.leadbooking.id);
        results.value.push(...onlyPrepAndKeyBookings);
        setBookingType(filterbookingtype.value);
        if (masterbookingidlistunderprepandkey.length > 0) {
          const uniqueArray = [...new Set(masterbookingidlistunderprepandkey)];
          (params.idlist = encodeURI(uniqueArray.join(","))),
            managementBookingSearch(params).then((bookings: Booking[]) => {
              results.value = [...results.value, ...bookings];
              setBookingType(filterbookingtype.value);
            });
        }
        results.value = results.value.filter((f: Booking) => {
          // Filter existing preset errors
          let existingPresetErrors = f.preseterrors.filter(
            (error: PresetError) =>
              error.category === "secondary" ||
              (error.category === "primary" &&
                ![2, 4, 5, 6, 7].includes(error.presetnumber))
          );
          // Generate new preset errors
          let primaryPresets: PresetError[] = checkBooking(f);
          let newPresetErrors = primaryPresets.filter(
            (error: PresetError) =>
              error.category === "primary" &&
              [2, 4, 5, 6, 7].includes(error.presetnumber)
          );
          // Combine existing and new preset errors
          f.preseterrors = [...existingPresetErrors, ...newPresetErrors];
          // Filter out bookings with no preset errors
          if (f.preseterrors.length === 0) {
            return false;
          }

          // Only show presets which are selected by user
          const presentInSelectedIndex = f.preseterrors.findIndex((e: PresetError) => {
            const i = presentErrorArray.findIndex((pe: any) => pe === e.presetnumber);
            if(i >= 0) return true;
            return false;
          })
          if(presentInSelectedIndex < 0) return false;

          return true;
        });
      } else {
        results.value.push(...bookings);
      }

      // Filter all shared bookings
      const noSharedBookings = results.value.filter((b: Booking) => b.subtype !== Booking.SHARED);
      results.value = [...noSharedBookings];

      showresultlist.value = true;
      setScrollposition();
    });
    setBooking(new Booking());
  }
  commanFunction();
};

const commanFunction = async () => {
  let params: any = {};
  let dateRange = await dateRangeFn();
  params.fromdate = dateRange.fromdate;
  params.todate = dateRange.todate;
  todaysunreadsmslogsresults.value = [];
  daterangeunreadsmslogsresults.value = [];
  futureunreadsmslogsresults.value = [];
  sortedunreadsmslogsresults.value.filter((f) => {
    let checkFlagCheck = false;
    if (params.fromdate && params.todate) {
      let startDate = moment(params.fromdate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      let endDate = moment(params.todate, "DD-MM-YYYY").format("YYYY-MM-DD");
      let checkDate = moment(f.startDate).format("YYYY-MM-DD");
      checkFlagCheck = moment(checkDate).isBetween(
        startDate,
        endDate,
        null,
        "[]"
      );
    }
    if (
      moment(f.bookingdate, "DD/MM/YYYY").isSame(
        moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY"),
        "day"
      )
    ) {
      todaysunreadsmslogsresults.value.push(f);
    } else if (checkFlagCheck) {
      daterangeunreadsmslogsresults.value.push(f);
    } else if (
      !moment(f.bookingdate, "DD/MM/YYYY").isSame(
        moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY"),
        "day"
      )
    ) {
      futureunreadsmslogsresults.value.push(f);
    }
  });
};

const sortedresults = computed(() => {
  const seenIds = new Set();
  const uniqueBookings = results.value.filter((booking) => {
    if (seenIds.has(booking.id)) {
      return false;
    } else {
      seenIds.add(booking.id);
      return true;
    }
  });
  return uniqueBookings;
  // return uniqueBookings.sort((b1: Booking, b2: Booking) => {
  //   // First order by customer
  //   let order = b1?.customer?.companyName.localeCompare(b2?.customer?.companyName);
  //   if (order === 0) order = b1?.customer?.branchName.localeCompare(b2?.customer?.branchName);
  //   if (order === 0) {
  //     if (moment.utc(b1.startdate).isAfter(moment.utc(b2.startdate))) {
  //       order = 1;
  //     } else if (moment.utc(b1.startdate).isBefore(moment.utc(b2.startdate))) {
  //       order = -1;
  //     } else {
  //       order = 0;
  //     }
  //   }
  //   return order;
  // });
});

const setScrollposition = () => {
  let resultpane: any = managementResults.value;
  let todaymoment = moment.utc(new Date()).startOf("day");
  var futurebooking: Booking | undefined = sortedresults.value.find(
    (b: Booking) => moment.utc(b.startdate).isAfter(todaymoment)
  );

  if (!futurebooking || !futurebooking?.id) {
    futurebooking =
      sortedresults.value.length > 0
        ? sortedresults.value[sortedresults.value.length - 1]
        : undefined;
  }

  nextTick(() => {
    if (futurebooking?.id) {
      futureBookingId.value = futurebooking?.id;
      let focusedBookingIndex = sortedresults.value.findIndex(
        (b: Booking) => b.id === futureBookingId.value
      );
      setTimeout(() => {
        if (resultpane) {
          resultpane.scrollTop = focusedBookingIndex * 186;
          resultpane.firstChild.firstChild.scrollTop =
            focusedBookingIndex * 186;
        }
      }, 1000);
    }
  });
};

const searchDisabled = computed(() => {
  let disabled = true;
  if (datefiltertype.value) {
    disabled =
      datefiltertype.value === "Date range"
        ? !(fromdate.value && todate.value)
        : false;
  }
  return disabled;
});

const showGoogleEventModal = (booking: Booking) => {
  googlebooking.value = booking;
  const modal = googleeventmodal.value as any;
  modal.show();
};

const clearCompanyname = () => {
  companyname.value = "";
  branchname.value = "";
};

const clearBranchname = () => {
  branchname.value = "";
};

const clearInspector = () => {
  inspector.value = new SelectOption();
};

const clearJobtype = () => {
  jobtype.value = new DictionaryReportType();
  internaljobtype.value = "";
};

const clearFilterType = () => {
  datefiltertype.value = "";
};
const customLabelForInternaljobtype = (internaljobtype: string): string => {
  var displayname = internaljobtype;
  return actProperty.customLabelForInternaljobtype(
    internaljobtypedisplayname.value,
    displayname
  );
};
const managePresentErrors = ($index: number) => {
  if (presentErrors.value[$index].flag === true) {
    presentErrors.value[$index].flag = false;
  } else {
    presentErrors.value[$index].flag = true;
  }
  if (!datefiltertype.value) {
    datefiltertype.value = "Date range";
    const dayOfWeekNumber = moment().format("d");
    const newDate = moment(fromdate.value)
      .add([5, 6, 0].includes(parseInt(dayOfWeekNumber)) ? 3 : 2, "days")
      .toDate();
    todate.value = newDate;
  }
  search();
};

const keyreturntbcfn = () => {
  if (keyreturntbc.value === true) {
    keyreturntbc.value = false;
  } else {
    keyreturntbc.value = true;
  }
  if (!datefiltertype.value) {
    datefiltertype.value = "Date range";
    const dayOfWeekNumber = moment().format("d");
    const newDate = moment(fromdate.value)
      .add([5, 6, 0].includes(parseInt(dayOfWeekNumber)) ? 3 : 2, "days")
      .toDate();
    todate.value = newDate;
  }
  search();
};
const removebookingfromlocal = (booking: Booking) => {
  let index = results.value.findIndex((f: Booking) => f.id === booking.id);
  results.value.splice(index, 1);
};

const removesmsbookingfromlocal = async (booking: Booking, flag: string) => {
  originalbooking.value = new Booking(booking);
  let bfindex = -1;
  let index = -1;
  if (flag === "sms") {
    index = sortedunreadsmslogsresults.value.findIndex(
      (f: Booking) => f.id === booking.id && f.smslogs.logs.length > 0
    );
    sortedunreadsmslogsresults.value.splice(index, 1);
    booking.smslogs.logs.forEach((l) => (l.unread = false));
  } else {
    index = sortedunreadsmslogsresults.value.findIndex(
      (f: Booking) =>
        f.id === booking.id && f.emaillogs.tenantemaillogs.length > 0
    );
    sortedunreadsmslogsresults.value.splice(index, 1);
    booking.emaillogs.tenantemaillogs.forEach((l) => (l.unread = false));
  }
  commanFunction();
  setBooking(new Booking());
  // remove selected
  bfindex = results.value.findIndex((f: Booking) => f.id === booking.id);

  results.value.splice(bfindex, 1);
  await markSMSEmailAsRead(booking);
  toasted.success(UndoSaveToaster, {
    onClick: async () => {
      await markSMSEmailAsRead(originalbooking.value);
      if (index !== -1) {
        sortedunreadsmslogsresults.value.splice(
          index,
          0,
          originalbooking.value
        );
        commanFunction();
      }
      if (bfindex !== -1) {
        results.value.splice(bfindex, 0, booking);
      }
    },
    timeout: 10000,
    closeOnClick: true,
  });
};

const clearAll = () => {
  presentErrors.value = presentErrors.value.map((obj) => ({
    ...obj,
    flag: false,
  }));
  //datefiltertype.value = '';

  // datefiltertype.value = "";
  // fromdate.value = new Date();
  // todate.value = new Date();
  anytext.value = "";
  jobtype.value = new DictionaryReportType();
  internaljobtype.value = "";
  companyname.value = "";
  branchname.value = "";
  inspector.value = new SelectOption();
  access.value = "";
  accessconfirmed.value = "";
  flexiappoitment.value = "";
  predictedtraveltime.value = "";
  tenantattending.value = "";
  missingtenantname.value = false;
  missingtenantmobile.value = false;
  missingtenantemail.value = false;
  missinguploadorreportref.value = false;
  cicotimeconflict.value = false;
  provisional.value = false;
  inabsence.value = false;
  cancelled.value = false;
  missingllname.value = false;
  missingllmobile.value = false;
  missingllemail.value = false;
  missingworksorder.value = false;
  notpaid.value = false;
  summaryemailafterco.value = false;
  smokecoalarmrequired.value = false;
  keyreleaseunconfirmed.value = false;
  keyreturntbc.value = false;
  notissued.value = false;
  store.state.selectedbooking = new Booking();
  search();
};
const selectAll = () => {
  if (!datefiltertype.value) {
    datefiltertype.value = "Date range";
    const dayOfWeekNumber = moment().format("d");
    const newDate = moment(fromdate.value)
      .add([5, 6, 0].includes(parseInt(dayOfWeekNumber)) ? 3 : 2, "days")
      .toDate();
    todate.value = newDate;
  }
  keyreturntbc.value = true;
  presentErrors.value = presentErrors.value.map((obj) => ({
    ...obj,
    flag: true,
  }));
  search();
};
const clearFilterBookingType = () => {
  filterbookingtype.value = "Client";
  setBookingType("Client");
};

const setBookingType = (val: string) => {
  let filterBookingList: Booking[] = [];
  if (val === "Time & Date") {
    filterBookingList = results.value.sort((b1: Booking, b2: Booking) => {
      if (moment.utc(b1.startdate).isAfter(moment.utc(b2.startdate))) {
        return 1;
      } else if (moment.utc(b1.startdate).isBefore(moment.utc(b2.startdate))) {
        return -1;
      } else {
        return 0;
      }
    });
  } else if (val === "Job type") {
    filterBookingList = results.value.sort((l1: Booking, l2: Booking) =>
      l1.jobtype.localeCompare(l2.jobtype)
    );
  } else if (val === "PI") {
    filterBookingList = results.value.sort((l1: Booking, l2: Booking) =>
      l1.inspector.name.localeCompare(l2.inspector.name)
    );
  } else {
    filterBookingList = results.value.sort((b1: Booking, b2: Booking) => {
      const companyName1 = b1?.customer?.companyName || '';
      const companyName2 = b2?.customer?.companyName || '';
      let branchName1 = b1?.keypickupbranchname ? b1?.keypickupbranchname : b1?.customer?.branchName;
      if(!branchName1) branchName1 = '';
      let branchName2 = b2?.keypickupbranchname ? b2?.keypickupbranchname : b2?.customer?.branchName;
      if(!branchName2) branchName2 = '';
      
      let order = companyName1.localeCompare(companyName2);
      
      if (order === 0) {
        order = branchName1.localeCompare(branchName2);
      }

      return order;
     });
  }
  results.value = [];
  results.value = filterBookingList;
};

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: datefiltertype.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datefiltertype).value = $event)),
                    options: datefiltertypeoptions.value,
                    "allow-empty": false,
                    taggable: false
                  }, _createSlots({ _: 2 }, [
                    (datefiltertype.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _withModifiers(clearFilterType, ["prevent","stop"]),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Date Filter"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          (datefiltertype.value === 'Date range')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_unref(DxDateBox), {
                            modelValue: fromdate.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fromdate).value = $event)),
                            "display-format": "dd/MM/yyyy",
                            type: "date",
                            "picker-type": "calendar",
                            "apply-value-mode": "instantly",
                            calendarOptions: { firstDayOfWeek: 1 },
                            onValueChanged: ensureToDateIsBeforeFromDate
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_unref(DxDateBox), {
                            modelValue: todate.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((todate).value = $event)),
                            "display-format": "dd/MM/yyyy",
                            type: "date",
                            "picker-type": "calendar",
                            "apply-value-mode": "instantly",
                            calendarOptions: { firstDayOfWeek: 1 },
                            onValueChanged: ensureFromDateIsAfterToDate
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presentErrors.value, (data, $index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-sm-12 mb-3",
                    key: $index,
                    style: {"display":"flex","flex-direction":"column","justify-content":"center"}
                  }, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary presetbtn",
                      onClick: ($event: any) => (managePresentErrors($index)),
                      style: {
                      'background-color': '#253746',
                      color: 'white',
                    }
                    }, [
                      _createTextVNode(_toDisplayString(data.message), 1),
                      (data.flag)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_21)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary presetbtn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (keyreturntbcfn())),
                    style: {
                      'background-color': '#253746',
                      color: 'white',
                    }
                  }, [
                    _createTextVNode(" Key return TBC"),
                    (keyreturntbc.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "col-sm-12 mr-1 mb-3",
              style: {"padding-right":"30px"}
            }, [
              _createElementVNode("div", {
                class: "row",
                style: {"float":"right","justify-content":"center"}
              }, [
                _createElementVNode("div", { class: "ml-1" }, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary",
                    onClick: clearAll
                  }, " Clear All ")
                ]),
                _createElementVNode("div", { class: "ml-1" }, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary",
                    onClick: selectAll
                  }, " Select All ")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control height-43",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((anytext).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      anytext.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: jobtype.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((jobtype).value = $event)),
                    options: jobtypeoptions.value,
                    "custom-label": customLabelForReportType,
                    "allow-empty": true,
                    taggable: false
                  }, _createSlots({ _: 2 }, [
                    (jobtype.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _withModifiers(clearJobtype, ["prevent","stop"]),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Job type Filter"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          (jobtype.value != null && jobtype.value.slug)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_singleselect_text, {
                        modelValue: internaljobtype.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((internaljobtype).value = $event)),
                        options: reorderedinternaljobtypelist.value,
                        "custom-label": customLabelForInternaljobtype,
                        "allow-empty": true,
                        taggable: false
                      }, _createSlots({ _: 2 }, [
                        (jobtype.value)
                          ? {
                              name: "clear",
                              fn: _withCtx(() => [
                                _createElementVNode("i", {
                                  onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (internaljobtype.value = ''), ["prevent","stop"])),
                                  class: "multiselect__clear fa fa-times",
                                  "aria-label": "Clear Internal Job type Filter"
                                }, null, 32)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["modelValue", "options"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: companyname.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((companyname).value = $event)),
                    options: companyNameOptions.value,
                    "allow-empty": true,
                    taggable: false,
                    onSelect: setBranchnameOptions
                  }, _createSlots({ _: 2 }, [
                    (companyname.value != null && companyname.value.length)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _withModifiers(clearCompanyname, ["prevent","stop"]),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Company Name"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          (companyname.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_singleselect_text, {
                        modelValue: branchname.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((branchname).value = $event)),
                        options: branchNameOptions.value,
                        "allow-empty": true,
                        taggable: false
                      }, _createSlots({ _: 2 }, [
                        (branchname.value != null && branchname.value.length)
                          ? {
                              name: "clear",
                              fn: _withCtx(() => [
                                _createElementVNode("i", {
                                  onMousedown: _withModifiers(clearBranchname, ["prevent","stop"]),
                                  class: "multiselect__clear fa fa-times",
                                  "aria-label": "Clear Branch Name"
                                }, null, 32)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["modelValue", "options"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: inspector.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((inspector).value = $event)),
                    "track-by": "slug",
                    label: "name",
                    options: inspectorlist.value,
                    "allow-empty": true,
                    taggable: false
                  }, _createSlots({ _: 2 }, [
                    (inspector.value && inspector.value.slug)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _withModifiers(clearInspector, ["prevent","stop"]),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Who"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: access.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((access).value = $event)),
                    options: accessOptions.value,
                    "allow-empty": true,
                    taggable: false
                  }, _createSlots({ _: 2 }, [
                    (access.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (access.value = ''), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Access"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: accessconfirmed.value,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((accessconfirmed).value = $event)),
                    options: accessconfirmedOptions.value,
                    "allow-empty": true,
                    taggable: false
                  }, _createSlots({ _: 2 }, [
                    (accessconfirmed.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (accessconfirmed.value = ''), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Access confirmed"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: flexiappoitment.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((flexiappoitment).value = $event)),
                    options: flexiappoitmentslist.value,
                    "allow-empty": true,
                    taggable: false
                  }, _createSlots({ _: 2 }, [
                    (flexiappoitment.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (flexiappoitment.value = ''), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Flexi Appointments"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: predictedtraveltime.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((predictedtraveltime).value = $event)),
                    options: predictedtraveltimeoptions.value,
                    "allow-empty": true,
                    taggable: false
                  }, _createSlots({ _: 2 }, [
                    (predictedtraveltime.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (predictedtraveltime.value = ''), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Predicted travel time exceeds scheduled allowance"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", _hoisted_81, [
                  _createVNode(TriStateToggle, {
                    value: tenantattending.value,
                    onSelect: tenantAttendingSelect
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _hoisted_85,
                _createElementVNode("div", _hoisted_86, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: missingtenantname.value,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((missingtenantname).value = $event)),
                    onValueChanged: _cache[20] || (_cache[20] = ($event: any) => (missingtenantname.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _hoisted_90,
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: missingtenantmobile.value,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((missingtenantmobile).value = $event)),
                    onValueChanged: _cache[22] || (_cache[22] = ($event: any) => (missingtenantmobile.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: missingtenantemail.value,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((missingtenantemail).value = $event)),
                    onValueChanged: _cache[24] || (_cache[24] = ($event: any) => (missingtenantemail.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _hoisted_100,
                _createElementVNode("div", _hoisted_101, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: missingllmobile.value,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((missingllmobile).value = $event)),
                    onValueChanged: _cache[26] || (_cache[26] = ($event: any) => (missingllmobile.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          (isuploadorlinktypejob.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _hoisted_105,
                    _createElementVNode("div", _hoisted_106, [
                      _createVNode(_unref(DxSwitch), {
                        modelValue: missinguploadorreportref.value,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((missinguploadorreportref).value = $event)),
                        onValueChanged: _cache[28] || (_cache[28] = ($event: any) => (missinguploadorreportref.value = $event.value))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _hoisted_110,
                _createElementVNode("div", _hoisted_111, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: cicotimeconflict.value,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((cicotimeconflict).value = $event)),
                    onValueChanged: _cache[30] || (_cache[30] = ($event: any) => (cicotimeconflict.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("div", _hoisted_114, [
                _hoisted_115,
                _createElementVNode("div", _hoisted_116, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: provisional.value,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((provisional).value = $event)),
                    onValueChanged: _cache[32] || (_cache[32] = ($event: any) => (provisional.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _hoisted_120,
                _createElementVNode("div", _hoisted_121, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: inabsence.value,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((inabsence).value = $event)),
                    onValueChanged: _cache[34] || (_cache[34] = ($event: any) => (inabsence.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _hoisted_125,
                _createElementVNode("div", _hoisted_126, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: cancelled.value,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((cancelled).value = $event)),
                    onValueChanged: _cache[36] || (_cache[36] = ($event: any) => (cancelled.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("div", _hoisted_129, [
                _hoisted_130,
                _createElementVNode("div", _hoisted_131, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: missingllname.value,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((missingllname).value = $event)),
                    onValueChanged: _cache[38] || (_cache[38] = ($event: any) => (missingllname.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_132, [
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, [
                _hoisted_135,
                _createElementVNode("div", _hoisted_136, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: missingllemail.value,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((missingllemail).value = $event)),
                    onValueChanged: _cache[40] || (_cache[40] = ($event: any) => (missingllemail.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _hoisted_140,
                _createElementVNode("div", _hoisted_141, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: missingworksorder.value,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((missingworksorder).value = $event)),
                    onValueChanged: _cache[42] || (_cache[42] = ($event: any) => (missingworksorder.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, [
                _hoisted_145,
                _createElementVNode("div", _hoisted_146, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: notpaid.value,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((notpaid).value = $event)),
                    onValueChanged: _cache[44] || (_cache[44] = ($event: any) => (notpaid.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("div", _hoisted_148, [
              _createElementVNode("div", _hoisted_149, [
                _hoisted_150,
                _createElementVNode("div", _hoisted_151, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: keyreleaseunconfirmed.value,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((keyreleaseunconfirmed).value = $event)),
                    onValueChanged: _cache[46] || (_cache[46] = ($event: any) => (keyreleaseunconfirmed.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_152, [
            _createElementVNode("div", _hoisted_153, [
              _createElementVNode("div", _hoisted_154, [
                _hoisted_155,
                _createElementVNode("div", _hoisted_156, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: smokecoalarmrequired.value,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((smokecoalarmrequired).value = $event)),
                    onValueChanged: _cache[48] || (_cache[48] = ($event: any) => (smokecoalarmrequired.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("div", _hoisted_159, [
                _hoisted_160,
                _createElementVNode("div", _hoisted_161, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: summaryemailafterco.value,
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((summaryemailafterco).value = $event)),
                    onValueChanged: _cache[50] || (_cache[50] = ($event: any) => (summaryemailafterco.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_162, [
            _createElementVNode("div", _hoisted_163, [
              _createElementVNode("div", _hoisted_164, [
                _hoisted_165,
                _createElementVNode("div", _hoisted_166, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: notissued.value,
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((notissued).value = $event)),
                    onValueChanged: _cache[52] || (_cache[52] = ($event: any) => (notissued.value = $event.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_167, [
      _hoisted_168,
      _createVNode(UnreadSmsEmailLogs, {
        results: sortedunreadsmslogsresults.value,
        todaysunreadsmslogsresults: todaysunreadsmslogsresults.value,
        daterangeunreadsmslogsresults: daterangeunreadsmslogsresults.value,
        futureunreadsmslogsresults: futureunreadsmslogsresults.value,
        onSmslogsselected: updateManageFilter,
        onRemovesmsbookingfromlocal: removesmsbookingfromlocal
      }, null, 8, ["results", "todaysunreadsmslogsresults", "daterangeunreadsmslogsresults", "futureunreadsmslogsresults"])
    ]),
    _createElementVNode("div", {
      class: "col-md-4",
      ref_key: "managementResults",
      ref: managementResults
    }, [
      _createElementVNode("h3", null, [
        _createTextVNode(" Bookings List "),
        (sortedresults.value.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_169, "- " + _toDisplayString(sortedresults.value.length), 1))
          : _createCommentVNode("", true)
      ]),
      (sortedresults.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
            _createElementVNode("div", _hoisted_171, [
              _createElementVNode("div", _hoisted_172, [
                _hoisted_173,
                _hoisted_174,
                _createElementVNode("div", _hoisted_175, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: filterbookingtype.value,
                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((filterbookingtype).value = $event)),
                    options: filterbookingtypeoptions.value,
                    "allow-empty": true,
                    taggable: false,
                    onSelect: setBookingType
                  }, _createSlots({ _: 2 }, [
                    (filterbookingtype.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[53] || (_cache[53] = _withModifiers(($event: any) => (clearFilterBookingType()), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Filter Booking"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(ManagementResults, {
        futurebookingid: futureBookingId.value,
        results: sortedresults.value,
        onSelectgooglebooking: showGoogleEventModal,
        onSelectbooking: updateManageFilter,
        onRemovebookingfromlocal: removebookingfromlocal
      }, null, 8, ["futurebookingid", "results"])
    ], 512),
    _createElementVNode("nav", _hoisted_176, [
      _createElementVNode("div", _hoisted_177, [
        _createElementVNode("div", _hoisted_178, [
          _createElementVNode("div", _hoisted_179, [
            _hoisted_180,
            _createElementVNode("div", _hoisted_181, [
              _createElementVNode("button", {
                class: "btn btn-light",
                onClick: [
                  search,
                  _cache[55] || (_cache[55] = _withModifiers(() => {}, ["stop"]))
                ],
                style: {"margin-left":"auto"},
                disabled: searchDisabled.value
              }, [
                _hoisted_183,
                _createTextVNode(" Search ")
              ], 8, _hoisted_182)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(DraggableModal, {
      "modal-id": 'floorplan-viewer',
      document: floorplan.value[0],
      title: 'Floor plan'
    }, null, 8, ["document"]),
    _createVNode(DraggableModal, {
      "modal-id": 'rates-viewer',
      document: ratedocument.value,
      title: 'Rates'
    }, null, 8, ["document"]),
    _createVNode(DraggableModal, {
      "modal-id": 'dataentrydocument-viewer',
      document: dataentrydocuments.value[0],
      title: 'Dataentry PDF'
    }, null, 8, ["document"]),
    _createVNode(AuditlogsModal, {
      name: "manageauditlogs-modal",
      ref_key: "auditLogsModal",
      ref: auditLogsModal
    }, null, 512),
    _createVNode(GoogleEventModal, {
      ref_key: "googleeventmodal",
      ref: googleeventmodal,
      booking: googlebooking.value
    }, null, 8, ["booking"]),
    _createVNode(BookingCancelModal, {
      ref_key: "bookingCancelModal",
      ref: bookingCancelModal,
      name: "cancel-booking-modal"
    }, null, 512),
    _createVNode(_unref(ModalsContainer))
  ]))
}
}

})